/**
 * Type-safe wrapper of `Object.entries`
 *
 * @template T extends object - typeof object to get the entries of
 *
 * @param obj - Object to get the entries of
 * @returns Type-safe array of provided object's entries
 */
export const getObjectEntries = <T extends object>(obj: T): [keyof T, T[keyof T]][] => {
  const keys = Object.entries(obj);
  return keys as [keyof T, T[keyof T]][];
};
